<!--
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-02-26 10:51:22
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-11-06 16:14:41
 * @FilePath: /designcenter/src/layout/components/Navbar.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="navbar" :class="{ 'manual-navbar': $route.path === '/operation-manual' }">
    <div class="navbar-left">
      <a :href="handleFsLink('/')">
        <img class="logo" src="https://resource.fs.com/mall/generalImg/20250515182750zmylkq.svg" alt="logo" />
      </a>
      <span class="line"></span>
      <img class="text" src="https://resource.fs.com/mall/generalImg/20250606151911jsqmvd.svg" alt="design center" />
    </div>
    <div class="navbar-right">
      <div class="navbar-user">
        <CustomSelect
          ref="selectProjectRef"
          v-if="$route.path !== '/operation-manual'"
          v-model="currentProjectId"
          :options="allProjectOptions"
          placeholder="Select ..."
          :searchable="true"
          @change="handleChangeProject"
        >
          <template #footer>
            <div class="select_footer_box">
              <div class="footer" @click.stop="addProject">
                <span class="iconfont iconfont_add icon-a-addproduct1"></span> <span class="text">Add Project</span>
              </div>
              <div class="footer" @click.stop="manageProjects">
                <span class="iconfont iconfont_manage icon-guanlixiangmu"></span>
                <span class="text">Manage Projects</span>
              </div>
            </div>
          </template>
        </CustomSelect>
        <span class="iconfont iconfont_nav icon-Feedback" @click.stop="showFeedback"></span>
        <span
          class="iconfont iconfont_nav icon-a-ContatUs-lianxiwomen"
          @click.stop="contactClick"
          title="Assistance"
        ></span>
        <HeaderAccount />
      </div>
    </div>
  </div>

  <FeedBackPopup ref="feedBackPopupRef" />
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useProjectStore } from '@/store/project'
import { useUserStore } from '@/store/user'
import { useHeaderStore } from '@/store/header'
import { userLoginLog } from '@/api/modules/user'
// import Icon from '@/components/Icon/Icon.vue'
import HeaderAccount from './HeaderAccount.vue'
import CustomSelect from './CustomSelect.vue'
import FeedBackPopup from '@/components/FeedBackPopup/FeedBackPopup.vue'
import { useRouter, useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { handleFsLink } from '@/utils'
import { useProductSelectionStore } from '@/store/productSelection'
import { trackEvent } from '@/utils/analytics'

interface CustomSelectInstance {
  hideDropdown: () => void
}

interface AddProjectPopupInstance {
  showDialog: () => void
}
const productSelectionStore = useProductSelectionStore()
const headerStore = useHeaderStore()
const projectStore = useProjectStore()
const userStore = useUserStore()
const { allProjectOptions, currentProjectId, currentTemplateId } = storeToRefs(projectStore)
const router = useRouter()
const selectProjectRef = ref<CustomSelectInstance | null>(null)
const feedBackPopupRef = ref<AddProjectPopupInstance | null>(null)
// const selectedProject = ref<number | null>(localStorage.getItem('currentProjectId') ? parseInt(localStorage.getItem('currentProjectId') || '') : null)

const addProject = () => {
  selectProjectRef?.value?.hideDropdown()
  headerStore.showCreateProjectPopup()
  trackEvent({
    eventCategory: 'dec_topology',
    eventAction: 'project_add_click',
    eventLabel: 'add_project',
  })
}

const handleChangeProject = (item: any) => {
  console.log('item', item)
  localStorage.setItem('currentTemplateTypeId', item.templateTypeId)
  productSelectionStore.clearSelectedProductIds()
  projectStore.setCurrentProjectId(item.value)
  if (item.templateId === 0 && item.isCustomized === 0) {
    headerStore.showSelectTemplatePopup()
  } else {
    projectStore.setCurrentTemplateId(item.templateId)
    router.push('/design-center')
  }
}
const showFeedback = () => {
  trackEvent({
    eventCategory: 'dec_topology',
    eventAction: 'feedback_click',
    eventLabel: 'feedback',
  })
  feedBackPopupRef?.value?.showDialog()
}

const contactClick = () => {
  trackEvent({
    eventCategory: 'dec_topology',
    eventAction: 'contactUs_click',
    eventLabel: 'contactUs',
  })
  window.open(handleFsLink('/product_and_project_inquiry.html'))
}
const manageProjects = () => {
  trackEvent({
    eventCategory: 'dec_topology',
    eventAction: 'project_manage_click',
    eventLabel: 'manage_projects',
  })
  selectProjectRef?.value?.hideDropdown()
  router.push({ path: '/project' })
}

onMounted(async () => {
  projectStore.getAllProjectList()
  await userStore.getCustomerType()
  await userStore.getUser()
  console.log('userStore', userStore.customersId)
  await userLoginLog({ userId: userStore.customersId })
})
</script>

<style lang="scss" scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: 0 24px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
  &.manual-navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // z-index: 1000;
  .navbar-left {
    display: flex;
    align-items: center;

    .line {
      width: 1px;
      height: 20px;
      background-color: #4c4948;
      margin: 0 8px;
    }

    .logo {
      display: inline-block;
      width: 76px;
    }

    .text {
      display: inline-block;
      width: 156px;
    }
  }

  .navbar-right {
    display: flex;
    align-items: center;

    .navbar-user {
      display: flex;
      align-items: center;
      gap: 12px;
      cursor: pointer;
    }
  }
}

.select_footer_box {
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eeeeee;

  .footer {
    height: 36px;
    width: 50%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    color: #19191a;
    @include font14;

    &:hover {
      .text {
        text-decoration: underline;
      }
    }
  }

  .iconfont {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 1;
    font-size: 16px;
    margin-right: 4px;
  }
}

.iconfont_nav {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 8px;
  font-size: 24px;
  border-radius: 4px;
  transform: all 0.3s;

  &:hover {
    background-color: #f2f2f2;
  }
}
</style>
